import { validPublicIdentifier } from '../api/public-identifiers.mjs';

const invoicePathPattern = /^\/invoices\/([^/]+)$/;

export function parsePayerInvoiceReference(value, currentOrigin) {
  const reference = String(value || '').trim();
  if (validPublicIdentifier(reference)) return reference;

  let base;
  let parsed;
  try {
    base = new URL(currentOrigin);
    parsed = new URL(reference, base);
  } catch {
    throw new Error('Enter an invoice link or code from this site.');
  }

  if (
    parsed.origin !== base.origin ||
    parsed.username ||
    parsed.password ||
    parsed.search ||
    parsed.hash
  ) {
    throw new Error('Enter an invoice link or code from this site.');
  }

  const match = invoicePathPattern.exec(parsed.pathname);
  const token = match?.[1] || '';
  if (!validPublicIdentifier(token)) {
    throw new Error('Enter a valid invoice link or code.');
  }
  return token;
}
